// extracted by mini-css-extract-plugin
export default {"DoctorSelectInputsection":"PatientCare_DoctorSelectInputsection__tsWM8","container":"PatientCare_container__Q8MTE"};